import {http} from '@/http'

export default {
  create(formData) {
    return http.post('/medical-leaves', formData, {
      headers: {'Content-Type': 'multipart/form-data'},
    })
  },
  update(id, formData) {
    return http.put(`/medical-leaves/${id}`, formData, {
      headers: {'Content-Type': 'multipart/form-data'},
    })
  },
  getAll(params) {
    return http.get('/medical-leaves', {params})
  },
  get(id) {
    return http.get(`/medical-leaves/${id}`)
  },
  getByEmployee(employeeId) {
    return http.get(`/medical-leaves/employee/${employeeId}`)
  },
  // companyId (opcional) acota el acumulado del año a esa empresa (el contador de 20 días es por empresa).
  getSummary(employeeId, companyId) {
    return http.get(`/medical-leaves/employee/${employeeId}/summary`, {
      params: companyId ? {companyId} : {},
    })
  },
  // Preview year-aware del split empleador/EsSalud de un DM prospectivo (misma lógica que la persistencia).
  previewDays(employeeId, companyId, startDate, endDate) {
    return http.get('/medical-leaves/preview-days', {
      params: {employeeId, companyId, startDate, endDate},
    })
  },
  // Chequeo de solape con vacaciones APROBADAS del colaborador (solo advertencia, no bloquea).
  checkVacationOverlap(employeeId, startDate, endDate) {
    return http.get('/medical-leaves/vacation-overlap-check', {
      params: {employeeId, startDate, endDate},
    })
  },
  finalize(id, data) {
    return http.put(`/medical-leaves/${id}/finalize`, data)
  },
  cancel(id, data) {
    return http.put(`/medical-leaves/${id}/cancel`, data)
  },
  annulMedicalLeave(id, reason) {
    return http.patch(`/medical-leaves/${id}/annul`, { reason })
  },
  annulBatch(ids, reason) {
    return http.patch('/medical-leaves/annul-batch', { ids, reason })
  },
  // Registrar / actualizar el cobro EsSalud de un DM FINALIZADO (endpoint dedicado).
  registerCollected(id, data) {
    return http.patch(`/medical-leaves/${id}/collected`, data)
  },
  downloadXlsx(data) {
    return http.post('/medical-leaves/xlsx', data, {responseType: 'blob'})
  },
  uploadCertificate(id, file) {
    const formData = new FormData()
    formData.append('file', file)
    return http.put(`/medical-leaves/${id}/certificate`, formData, {
      headers: {'Content-Type': 'multipart/form-data'},
    })
  },
  downloadCertificate(id) {
    return http.get(`/medical-leaves/${id}/certificate`, {responseType: 'blob'})
  },
}
